import { Divider, Trans } from '@/components'

import { AdminInstanceListView } from '../components/AdminInstanceListView'
import { ViewSwitcher } from '../components/ViewSwitcher'

export function AdminInstanceView() {
  return (
    <div className="card bg-panel-white h-full overflow-y-auto">
      {/* Unified header section */}
      <div className="flex h-[60px] items-center justify-start gap-2">
        <div className="h6">
          <Trans i18nKey="instance.title">My Instances</Trans>
        </div>
        {/* ViewSwitcher to navigate between Member/Admin views */}
        <ViewSwitcher />
      </div>

      <Divider />

      {/* Admin View: Show all team member instances with management capabilities */}
      <AdminInstanceListView hideHeader={true} />
    </div>
  )
}
